import type { ApiError } from '@/types/api.types';

type TranslateFn = (key: string) => string;

export function mapTreatmentsError(error: ApiError, t: TranslateFn, fallbackKey: string): string {
  switch (error.code) {
    case 'UNAUTHORIZED':
      return t('specialties.errors.unauthorized');
    case 'FORBIDDEN':
      return t('specialties.errors.forbidden');
    case 'ACCOUNT_NOT_FOUND':
      return t('specialties.errors.accountNotFound');
    case 'SPECIALTY_NOT_FOUND':
      return t('specialties.errors.specialtyNotFound');
    case 'TREATMENT_NOT_FOUND':
      return t('specialties.treatments.errors.notFound');
    case 'VALIDATION_ERROR':
      return t('specialties.errors.validationError');
    case 'INVALID_STATUS_TRANSITION':
      return t('specialties.treatments.errors.invalidTransition');
    case 'INTERNAL_SERVER_ERROR':
      return t('specialties.errors.serverError');
    default:
      return t(fallbackKey);
  }
}
